import type { File } from '@/domain/files';
import { api } from '@/utils/configuration';
import { crudService } from '@/utils/request';
import type { GenericAbortSignal } from 'axios';

export const CommunityPhotosService = {
  search: async ([communityId]: [number], signal?: GenericAbortSignal) =>
    await crudService.get<File[]>(`${api.COMMUNITIES}/${communityId}/images`, {
      signal,
    }),
};
